import CustomizableSelect from "Global/Components/CommonComponents/CustomizableSelect/CustomizableSelect";
import EditableCustomizableSelect from "Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect";
import React from "react";
import { StructureEditableDataArray } from "../../Functions/StructureEditableDataArray";
import { StructureAnswersForSelectables } from "Global/Components/Generators/FormElementCreatorByType/Functions/StructureAnswersForSelectables";

const EditTernaryRadCheck = ({ field, element, onChange }) => {

  const isPersian = (text) => {
    // Persian Unicode range
    const persianRegex = /[\u0600-\u06FF\u FB8A\u067E\u0686\u06AF]/;
    return persianRegex.test(text);
  };

  
  return (
    <React.Fragment>
      {field.value.length > 0 ? (
        <EditableCustomizableSelect
          initialData={StructureEditableDataArray(field?.UiValue)}
          onChange={onChange}
          SelectableDataArray={StructureAnswersForSelectables(
            element?.ElsRecord?.ListDefaultAnswer,
            "RadCheckedDropDownList"
          )}
          label={element?.LablelNameForWeb}
          isEnglish={false}
          swipleToLeftTitle={true}
          CompleteOutPut={true}
        />
      ) : (
        <CustomizableSelect
          onChange={onChange}
          SelectableDataArray={StructureAnswersForSelectables(
            element?.ElsRecord?.ListDefaultAnswer,
            "RadCheckedDropDownList"
          )}
          label={element?.LablelNameForWeb}
          isEnglish={false}
          swipleToLeftTitle={!isPersian(element?.LablelNameForWeb)}
          CompleteOutPut={true}
        />
      )}
    </React.Fragment>
  );
};

export default EditTernaryRadCheck;
